<template>
    <div id="surveyForm">
        <p class="font-semibold text-lg text-yellow-600">Please answer all questions to the best of your ability whether they apply to your specific objectives or not.</p><br>

        <fieldset>
            <div class="flex flex-wrap border border-gray-200 mb-4">
                <div class="p-6">

                    <div class="w-full mb-4">
                        <div class="text-md font-bold mb-2">1. I want to focus mostly on becoming successful at...<sup>*</sup></div>
                        <label for="field01-01" class="inline-block w-full form-label-radio">
                            <input @input="errors.field01 = false" v-model="form.field01" type="radio" id="field01-01" class="form-radio mr-2" name="field01" value="Basic technical analysis / chart reading / understanding price action">
                            Basic technical analysis / chart reading / understanding price action
                        </label>
                        <label for="field01-02" class="inline-block w-full form-label-radio">
                            <input @input="errors.field01 = false" v-model="form.field01" type="radio" id="field01-02" class="form-radio mr-2" name="field01" value="Basic options trading techniques">
                            Basic options trading techniques
                        </label>
                        <label for="field01-03" class="inline-block w-full form-label-radio">
                            <input @input="errors.field01 = false" v-model="form.field01" type="radio" id="field01-03" class="form-radio mr-2" name="field01" value="Advanced option trading techniques">
                            Advanced option trading techniques
                        </label>
                        <label for="field01-04" class="inline-block w-full form-label-radio">
                            <input @input="errors.field01 = false" v-model="form.field01" type="radio" id="field01-04" class="form-radio mr-2" name="field01" value="Futures trading">
                            Futures trading
                        </label>
                        <label for="field01-05" class="inline-block w-full form-label-radio">
                            <input @input="errors.field01 = false" v-model="form.field01" type="radio" id="field01-05" class="form-radio mr-2" name="field01" value="Learning one methodology that I can trade in any investment sector">
                            Learning one methodology that I can trade in any investment sector
                        </label>
                        <div class="error" v-if="errors.field01"> {{ errors.field01 }}</div>
                    </div>

                    <div class="w-full mb-4">
                        <div class="text-md font-bold mb-2">2. I generally like to trade:<sup>*</sup></div>
                        <label for="field02-01" class="inline-block w-full form-label-radio">
                            <input @input="errors.field02 = false" v-model="form.field02" type="radio" id="field02-01" class="form-radio mr-2" name="field02" value="Futures Contracts">
                            Futures Contracts
                        </label>
                        <label for="field02-02" class="inline-block w-full form-label-radio">
                            <input @input="errors.field02 = false" v-model="form.field02" type="radio" id="field02-02" class="form-radio mr-2" name="field02" value="Futures Options">
                            Futures Options
                        </label>
                        <label for="field02-03" class="inline-block w-full form-label-radio">
                            <input @input="errors.field02 = false" v-model="form.field02" type="radio" id="field02-03" class="form-radio mr-2" name="field02" value="FOREX">
                            FOREX
                        </label>
                        <label for="field02-04" class="inline-block w-full form-label-radio">
                            <input @input="errors.field02 = false" v-model="form.field02" type="radio" id="field02-04" class="form-radio mr-2" name="field02" value="Binary Options">
                            Binary Options
                        </label>
                        <label for="field02-05" class="inline-block w-full form-label-radio">
                            <input @input="errors.field02 = false" v-model="form.field02" type="radio" id="field02-05" class="form-radio mr-2" name="field02" value="I am not sure yet">
                            I am not sure yet
                        </label>
                        <div class="error" v-if="errors.field02"> {{ errors.field02 }}</div>
                    </div>

                    <div class="w-full mb-4">
                        <div class="text-md font-bold mb-2">3. Do you find learning about charts and strategies to be interesting/exciting?<sup>*</sup></div>
                        <label for="field03-01" class="inline-block w-full form-label-radio">
                            <input @input="errors.field03 = false" v-model="form.field03" type="radio" id="field03-01" class="form-radio mr-2" name="field03" value="Yes">
                            Yes
                        </label>
                        <label for="field03-02" class="inline-block w-full form-label-radio">
                            <input @input="errors.field03 = false" v-model="form.field03" type="radio" id="field03-02" class="form-radio mr-2" name="field03" value="Not really">
                            Not really
                        </label>
                        <div class="error" v-if="errors.field03"> {{ errors.field03 }}</div>
                    </div>

                    <div class="w-full mb-4">
                        <div class="text-md font-bold mb-2">4. You trade because:<sup>*</sup></div>
                        <label for="field04-01" class="inline-block w-full form-label-radio">
                            <textarea @input="errors.field04 = false" :class="{'is-invalid': errors.field04}" v-model="form.field04" class="form-input-inline" id="field04-01" name="field04" type="text" rows="4" placeholder=""></textarea>
                        </label>
                        <div class="error" v-if="errors.field04"> {{ errors.field04 }}</div>
                    </div>

                    <div class="w-full mb-4">
                        <div class="text-md font-bold mb-2">5. How long have you been a trader?<sup>*</sup></div>
                        <label for="field05-01" class="inline-block w-full form-label-radio">
                            <input @input="errors.field05 = false" :class="{'is-invalid': errors.field05}" v-model="form.field05" class="form-input" id="field05-01" name="field05" type="text" placeholder="">
                        </label>
                        <div class="error" v-if="errors.field05"> {{ errors.field05 }}</div>
                    </div>

                    <div class="w-full mb-4">
                        <div class="text-md font-bold mb-2">6. Describe your experience level:</div>
                        <label for="field06-01" class="inline-block w-full form-label-radio">
                            <input @input="errors.field06 = false" v-model="form.field06" type="radio" id="field06-01" class="form-radio mr-2" name="field06" value="Beginner – I am still going through the basic course - I’m paper trading">
                            <strong>Beginner</strong> – I am still going through the basic course - I’m paper trading
                        </label>
                        <label for="field06-02" class="inline-block w-full form-label-radio">
                            <input @input="errors.field06 = false" v-model="form.field06" type="radio" id="field06-02" class="form-radio mr-2" name="field06" value="Intermediate - I have done a little actual trading over the years">
                            <strong>Intermediate</strong> - I have done a little actual trading over the years
                        </label>
                        <label for="field06-03" class="inline-block w-full form-label-radio">
                            <input @input="errors.field06 = false" v-model="form.field06" type="radio" id="field06-03" class="form-radio mr-2" name="field06" value="Advanced - I trade but I’m not getting the returns I want, or I think I could do better">
                            <strong>Advanced</strong> - I trade but I’m not getting the returns I want, or I think I could do better
                        </label>
                        <div class="error" v-if="errors.field06"> {{ errors.field06 }}</div>
                    </div>

                    <div class="w-full mb-4">
                        <div class="text-md font-bold mb-2">7. What are your feelings or approach to money management?<sup>*</sup></div>
                        <label for="field07-01" class="inline-block w-full form-label-radio">
                            <textarea @input="errors.field07 = false" :class="{'is-invalid': errors.field07}" v-model="form.field07" class="form-input-inline" id="field07-01" name="field07" type="text" rows="4" placeholder=""></textarea>
                        </label>
                        <div class="error" v-if="errors.field07"> {{ errors.field07 }}</div>
                    </div>

                    <div class="w-full mb-4">
                        <div class="text-md font-bold mb-2">8. How much time can you spend a day (approximately) looking at charts:<sup>*</sup></div>
                        <label for="field08-01" class="inline-block w-full form-label-radio">
                            <input @input="errors.field08 = false" v-model="form.field08" type="radio" id="field08-01" class="form-radio mr-2" name="field08" value="All day">
                            All day
                        </label>
                        <label for="field08-02" class="inline-block w-full form-label-radio">
                            <input @input="errors.field08 = false" v-model="form.field08" type="radio" id="field08-02" class="form-radio mr-2" name="field08" value="3-4 hours">
                            3-4 hours
                        </label>
                        <label for="field08-03" class="inline-block w-full form-label-radio">
                            <input @input="errors.field08 = false" v-model="form.field08" type="radio" id="field08-03" class="form-radio mr-2" name="field08" value="1-2 hours">
                            1-2 hours
                        </label>
                        <label for="field08-04" class="inline-block w-full form-label-radio">
                            <input @input="errors.field08 = false" v-model="form.field08" type="radio" id="field08-04" class="form-radio mr-2" name="field08" value="30 minutes when I am lucky">
                            30 minutes when I am lucky
                        </label>
                        <label for="field08-05" class="inline-block w-full form-label-radio">
                            <input @input="errors.field08 = false" v-model="form.field08" type="radio" id="field08-05" class="form-radio mr-2" name="field08" value="I don’t want to look at charts- I just want to have someone tell me what to trade">
                            I don’t want to look at charts - I just want to have someone tell me what to trade
                        </label>
                        <div class="error" v-if="errors.field08"> {{ errors.field08 }}</div>
                    </div>

                    <div class="w-full mb-4">
                        <div class="text-md font-bold mb-2">9. Have you ever taken any other trading/investment courses?<sup>*</sup></div>
                        <label for="field09-01" class="inline-block w-full form-label-radio">
                            <input @input="errors.field09 = false; errors.field09c= false" v-model="form.field09" type="radio" id="field09-01" class="form-radio mr-2" name="field09" value="Yes">
                            Yes
                        </label>
                        <label for="field09-02" class="inline-block w-full form-label-radio">
                            <input @input="errors.field09 = false; errors.field09c= false" v-model="form.field09" type="radio" id="field09-02" class="form-radio mr-2" name="field09" value="No">
                            No
                        </label>
                        <label for="field09-03" class="inline-block w-full form-label-radio">
                            <input @input="errors.field09 = false; errors.field09c= false" v-model="form.field09" type="radio" id="field09-03" class="form-radio mr-2" name="field09" value="If so, which...">
                            If so, which...
                        </label>
                        <label class="inline-block w-full" v-show="form.field09 == 'If so, which...'">
                            <input @input="errors.field09c = false" :class="{'is-invalid': errors.field09c && form.field09 == 'If so, which...'}" v-model="form.field09c" class="form-input" name="field09c" type="text" placeholder="">
                        </label>
                        <div class="error" v-if="errors.field09"> {{ errors.field09 }}</div>
                        <div class="error" v-if="errors.field09c && form.field09 == 'If so, which...'"> {{ errors.field09c }}</div>
                    </div>

                    <div class="w-full mb-4">
                        <div class="text-md font-bold mb-2">10.What do you feel is the biggest hurdle or block that stands in the way of you being the trader you desire to be?<sup>*</sup></div>
                        <label for="field10-01" class="inline-block w-full form-label-radio">
                            <textarea @input="errors.field10 = false" :class="{'is-invalid': errors.field10}" v-model="form.field10" class="form-input-inline" id="field10-01" name="field10" type="text" rows="4" placeholder=""></textarea>
                        </label>
                        <div class="error" v-if="errors.field10"> {{ errors.field10 }}</div>
                    </div>

                    <div class="w-full mb-4">
                        <div class="text-md font-bold mb-2">11. What would you hope to get from working with Jim Prince and Jim's Inner Circle?<sup>*</sup></div>
                        <label for="field11-01" class="inline-block w-full form-label-radio">
                            <textarea @input="errors.field11 = false" :class="{'is-invalid': errors.field11}" v-model="form.field11" class="form-input-inline" id="field11-01" name="field11" type="text" rows="4" placeholder=""></textarea>
                        </label>
                        <div class="error" v-if="errors.field11"> {{ errors.field11 }}</div>
                    </div>

                    <div class="w-full mb-4">
                        <div class="text-md font-bold mb-2">12. Do you believe education provided by an experienced trader/coach can make you a better, more profitable trader?<sup>*</sup></div>
                        <label for="field12-01" class="inline-block w-full form-label-radio">
                            <input @input="errors.field12 = false" v-model="form.field12" type="radio" id="field12-01" class="form-radio mr-2" name="field12" value="Yes">
                            Yes
                        </label>
                        <label for="field12-02" class="inline-block w-full form-label-radio">
                            <input @input="errors.field12 = false" v-model="form.field12" type="radio" id="field12-02" class="form-radio mr-2" name="field12" value="No">
                            No
                        </label>
                        <div class="error" v-if="errors.field12"> {{ errors.field12 }}</div>
                    </div>

                    <div class="w-full border-t mt-4 mb-2 pt-4">
                        <div class="text-md font-bold text-yellow-600 mb-2">“YES! I'm ready to talk about working with Jim Prince in his exclusive Jim's Inner Circle program!”</div>
                        <div class="text-md font-bold mb-2">Great. Simply fill out your information below. Upon review of your application, one of my Senior Course Counselors will call you to review your responses, explore your trading goals, and discuss how Jim's Inner Circle can help.</div>
                    </div>

                    <div class="w-full mb-4">
                        <label class="form-label-class" for="name">Name<sup>*</sup></label>
                        <input @input="errors.name = false" :class="{'is-invalid': errors.name}" v-model="form.name" class="form-input" id="name" type="text" placeholder="Your Full Name">
                        <div class="error" v-if="errors.name"> {{ errors.name }}</div>
                    </div>

                    <div class="w-full mb-4">
                        <label class="form-label-class" for="email">Email Address<sup>*</sup></label>
                        <input @input="errors.email = false" :class="{'is-invalid': errors.email}" v-model="form.email" class="form-input" id="email" type="email" placeholder="name@domain.com">
                        <div class="error" v-if="errors.email"> {{ errors.email }}</div>
                    </div>

                    <div class="w-full mb-4">
                        <label class="form-label-class" for="phone">Phone Number<sup>*</sup></label>
                        <input @input="errors.phone = false" :class="{'is-invalid': errors.phone}" v-model="form.phone" class="form-input" id="phone" type="text" placeholder="e.g. +12223334444 or (222) 333-4444">
                        <div class="error" v-if="errors.phone"> {{ errors.phone }}</div>
                    </div>

                    <div class="w-full mb-4">
                        <label class="form-label-class" for="calltime">Best Time to Call</label>
                        <input v-model="form.calltime" class="form-input" id="calltime" type="text" placeholder="e.g. Between 4:00 p.m. and 5:00 p.m.">
                    </div>

                    <div class="w-full mb-4" v-if="!loggedIn">
                        <div id="captcha"></div>
                        <div class="error" v-if="errors.captcha">The reCAPTCHA was not entered correctly</div>
                    </div>

                    <div class="w-full p-0 mb-3 bg-red-500 px-2 py-1 text-white text-xs text-center" v-show="haveErrors()">
                        Please fill in the required fields and try again.
                    </div>

                    <div class="w-full mt-6 text-center">
                        <button :class="{'btn-disabled' : loading}" class="btn btn-yellow" @click="submit" type="button">
                            Submit Application
                        </button>
                    </div>

                </div>
            </div>
        </fieldset>

        <flash-message ref="flashRef" :seconds-to-display="6">
            <template #body>
                Your Survey has been sent! A response will be sent to {{ displayEmail }} shortly.
            </template>
        </flash-message>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';

const props = defineProps({
    siteKey: String,
});

const errors = ref({
    captcha: false,
    name: false,
    email: false,
    phone: false,
    // calltime: false,
    field01: false,
    field02: false,
    field03: false,
    field04: false,
    field05: false,
    field06: false,
    field07: false,
    field08: false,
    field09: false,
    field09c: false,
    field10: false,
    field11: false,
    field12: false,
});

const form = ref({
    captcha: '',
    name: '',
    email: (window.currentUser && window.currentUser.email) || '',
    phone: (window.currentUser && window.currentUser.phone_number) || '',
    calltime: '',
    field01: '',
    field02: '',
    field03: '',
    field04: '',
    field05: '',
    field06: '',
    field07: '',
    field08: '',
    field09: '',
    field09c: '',
    field10: '',
    field11: '',
    field12: '',
});

const loggedIn = ref((window.currentUser && window.currentUser.username) ? true : false);
const displayEmail = ref('');
const loading = ref(false);
const flashRef = ref(false);

const haveErrors = () => {
    return Object.keys(errors.value).find(e => errors.value[e] !== false);
};

const validate = () => {
    let valid = true;
    if (loggedIn.value) form.captcha = true;
    Object.keys(form).map((formName) => {
        if (formName == 'calltime') {
            return;
        }
        if (form[formName] === '') {
            if (formName == 'field09c' && form['field09'] !== 'If so, which...') {
                errors.value[formName] = false;
            } else if (['field01', 'field02', 'field03', 'field06', 'field08', 'field09', 'field12'].find(k => k == formName)) {
                errors.value[formName] = 'Please select one of these options.';
                valid = false;
            } else {
                errors.value[formName] = 'Please fill out this field.';
                valid = false;
            }
        }
    });
    return valid;
};

const updateCaptcha = (response) => {
    form.captcha = response;
};

const reset = () => {
    Object.keys(form).map((formName) => {
        form[formName] = '';
        errors.value[formName] = false;
    });

    if (!loggedIn.value) {
        errors.value['captcha'] = false;
        grecaptcha.reset();
    }
};

const submit = () => {
    const route = loggedIn.value ? window.route('post.survey-logged-in') : window.route('post.survey');

    if (!validate()) return;

    loading.value = true;

    const params = {
        formData: form.value,
        captcha: form.value.captcha,
        user: window.currentUser,
        resolution: {
            height: window.innerHeight,
            width: window.innerWidth,
        },
    };

    axios.post(route, params)
        .then((response) => {
            displayEmail.value = form.email;
            reset();
            flashRef.value.display('Thanks for filling out our form! Your form has been successfully sent.');
        }).catch((error) => {
            if (error.response.data.errors) {
                Object.keys(error.response.data.errors).map((formName) => {
                    errors.value[formName] = error.response.data.errors[formName][0];
                });
            } else {
                errors.value['captcha'] = 'The reCAPTCHA was not entered correctly';
            }

            if (!loggedIn.value) {
                grecaptcha.reset();
            }
        }).then(() => {
            loading.value = false;
        });
};

onMounted(() => {
    if (!loggedIn.value) {
        grecaptcha.render('captcha', {
            sitekey: props.siteKey,
            callback: updateCaptcha,
        });
    }
});
</script>

<style lang="scss">
#surveyForm {
    .form-input {
        margin-bottom: 0.3rem !important;
    }
    #captcha > div {
        width: 1px !important;
    }
    @media (max-width: 769px) {
        #captcha {
            transition: linear 100ms width;
            transform: scale(0.8);
            transform-origin: center left;
        }
    }
    @media (max-width: 319px) {
        #captcha {
            transform: scale(0.6);
        }
    }
}
</style>
